import React, { useCallback, useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ShowToast } from '../../../common/Toastr';
import fetchTimeliveAPI from '../../../common/fetchTimeliveAPI';
import { Dropdown } from 'react-bootstrap';
import clsx from 'clsx';
import { getValueFromResource, setItemStatus } from '../../../common/timeLiveFunction';
import { GetAccountGeoFenceProfile, setPageNo, setPageSize, setProfilePageNo, setProfilePageSize, updateProfilePagination } from './GeofencingSlice';
import Loader from '../../../common/Loader';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { getPagePermissions } from '../../dashboard/dashboardSlice';
import infoSVG from "../../../assets/image/info-SVG.svg";
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { TOOLTIP_STYLE } from "../../../common/TooltipStyle";
import PageSizeSelect from '../../../common/PageSizeSelect';
import CustomPagination from "../../../common/Pagination";

const GeofenceProfileList = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const { isLoading, profileList, profilePageNo, profilePageSize, startProfileRec, totalProfileItems } = useAppSelector((state) => state.geofencing);
    const navigate = useNavigate();
    const [permissions, setPermissions] = useState({
            IsList: false,
            IsAdd: false,
            IsEdit: false,
            IsDelete: false,
        });

    const resetProfileToFirstPage = useCallback((size: number) => {
        dispatch(updateProfilePagination({
            startProfileRec: 0,
            profilePageSize: size,
            profilePageNo: 1,
        }));
        // dispatch(GetAccountGeoFenceProfile({ profilePageNo: 1, profilePageSize: size }));
    }, [dispatch]);

    const handlePageChange = useCallback((page: number) => {
        dispatch(updateProfilePagination({
            startProfileRec: (page - 1) * Number(profilePageSize),
            profilePageSize: profilePageSize,
            profilePageNo: page,
        }));
        // dispatch(GetAccountGeoFenceProfile({ profilePageNo: page, profilePageSize: profilePageSize }));
    }, [dispatch, profilePageSize]);

    const handlePageSizeChange = useCallback((event: any) => {
        const { value } = event;
        resetProfileToFirstPage(Number(value));
    }, [resetProfileToFirstPage]);

     const getPermission = async () => {
            try {
                const res = await dispatch(getPagePermissions(514));
                if (res.meta?.requestStatus === 'fulfilled') {
                    if (!res?.payload?.IsList) {
                        navigate('../error/403');
                        return;
                    }
                    setPermissions({
                        IsList: res?.payload?.IsList ?? false,
                        IsAdd: res?.payload?.IsAdd ?? false,
                        IsEdit: res?.payload?.IsEdit ?? false,
                        IsDelete: res?.payload?.IsDelete ?? false,
                    });
                }
            } catch (error) {
                console.log(error);
            }
        };

    useEffect(() => {
        getPermission();
        dispatch(GetAccountGeoFenceProfile({ profilePageNo: profilePageNo, profilePageSize: profilePageSize }));
    }, [profilePageNo,profilePageSize])

    const handleDeletZone = async (id: any) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then(async (result) => {
                try {
                    const response = await fetchTimeliveAPI(`api/GeoFenceProfile/DeleteAccountGeoFenceProfile/${id}`, `DELETE`, '', true);
                    const json = await response.json();
                    if (json?.StatusCode === '200') {
                        ShowToast('Success', json.ResponseMessage, 'success', "toast-top-right");
                        dispatch(GetAccountGeoFenceProfile({ profilePageNo: profilePageNo, profilePageSize: profilePageSize }))
                    } else {
                        ShowToast('error', json.ResponseMessage, "error", "toast-top-right")
                    }
                } catch (error) {
                    console.log(error);
                }
            })
    }
    return (
        <div>
            {isLoading && <Loader />}
            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top bg-white fixed-top">
                    <h3 className="card-title fw-bold mainHeading d-flex align-items-center gap-1">
                        {getValueFromResource('Profile List', dispatch, t)}
                        <div
                            style={{ marginBottom: "2px" }}
                            data-tooltip-id="tooltip-description"
                            data-tooltip-content={getValueFromResource('Create and manage geofence profiles that group one or more geofence zones. These profiles can be assigned to employees to control where attendance actions are allowed based on location rules.', dispatch, t)}
                        >
                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                        </div>
                    </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="card-toolbar align-items-center">
                            <div className="d-flex align-items-center">
                                <PageSizeSelect onChange={handlePageSizeChange} />
                            </div>
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                            <div>
                                {(totalProfileItems > 0) ? (
                                    <CustomPagination
                                        currentPage={profilePageNo}
                                        onPageChange={handlePageChange}
                                        pageSize={profilePageSize}
                                        totalItems={totalProfileItems}
                                        start={startProfileRec}
                                        t={t}
                                    >
                                    </CustomPagination>
                                ) : null}
                            </div>
                        </div>
                        {permissions?.IsAdd &&
                            <>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                <button type="button"
                                    className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                                    style={{ marginRight: '2px', display: 'block' }}
                                    onClick={() => navigate('/addGeofenceProfile')}
                                >
                                    {getValueFromResource('Add Profile', dispatch, t)}

                                </button>
                            </>
                        }
                    </div>
                </div>
                <div className="card-Report-body">
                    <div className="table-responsive">
                        <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                            <thead>
                                <tr className="thHeading align-middle">
                                    <th style={{ width: '15%' }}> {getValueFromResource('Active / Inactive', dispatch, t)}</th>
                                    <th style={{ width: '60%' }}>{getValueFromResource('Profile Name', dispatch, t)}</th>
                                    <th style={{ width: '15%' }}>{getValueFromResource('Profile Code', dispatch, t)}</th>
                                    <th className='w-10 text-center'></th>
                                </tr>
                            </thead>
                            <tbody>
                                {profileList?.length > 0 && profileList?.map((item: any) => {
                                    return (
                                        <tr>
                                            <td>
                                                <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(item.IsDisabled ? "InActive" : "Active"))}>
                                                    {item.IsDisabled ? "InActive" : "Active"}
                                                </span>
                                            </td>
                                            <td className='text-gray-800  text-hover-primary custom-pointer-cursor '>
                                                <span onClick={() => navigate(`/addGeofenceProfile/${item?.AccountGeoFenceProfileId}/edit?from=profileList`)} className="d-block ">{item?.ProfileName}</span>
                                            </td>
                                            <td className='text-gray-800'>
                                                <span className="d-block ">{item?.ProfileCode}</span>
                                            </td>
                                            <td className='text-center'>
                                                <Dropdown
                                                    style={{ marginLeft: 1 }}
                                                    className={clsx('cursor-pointer symbol')}
                                                    data-kt-menu-attach='parent'
                                                    data-kt-menu-placement='bottom-end'
                                                >
                                                    <Dropdown.Toggle
                                                        variant="transparent"
                                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                        data-tooltip-id="tooltip-Description"
                                                        data-tooltip-content={getValueFromResource('More', dispatch, t)}
                                                        data-tooltip-place="top"
                                                    >
                                                        <i className="bi bi-three-dots fs-7"></i>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                        {permissions?.IsEdit && <div className='menu-hover-bg-sec'>
                                                            <Dropdown.Item
                                                                className="menu-item me-lg-0 "
                                                                onClick={() => navigate(`/addGeofenceProfile/${item?.AccountGeoFenceProfileId}/edit?from=profileList`)}
                                                            >
                                                                <span className="menu-icon custom-menu">
                                                                    <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title custom-menu-fontsize">
                                                                    {getValueFromResource('Edit', dispatch, t)}
                                                                </span>
                                                            </Dropdown.Item>
                                                        </div>}
                                                        {/* <div className='separator mb-1 mt-1 opacity-75 '></div>
                                                        <div className='menu-hover-bg-danger'>
                                                            <Dropdown.Item
                                                                className="menu-item me-lg-0 "
                                                                onClick={() => handleDeletZone(item?.AccountGeoFenceProfileId)}
                                                            >
                                                                <span className="menu-icon  custom-menu">
                                                                    <i className="bi bi-trash fs-6 delete-menu-icon-color " >
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title   delete-menu custom-menu-fontsize"  >
                                                                    {getValueFromResource('Delete', dispatch, t)}
                                                                </span>
                                                            </Dropdown.Item>
                                                        </div> */}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <ReactTooltip
                id="tooltip-description"
                style={TOOLTIP_STYLE}
                place="bottom"
                delayShow={100}
                delayHide={100}
                clickable
                render={({ content }) => {
                    const isLongContent = content && content?.length > 90;
                    return (
                        <div style={{ maxWidth: isLongContent ? '380px' : '220px' }}>
                            {content}
                        </div>
                    );
                }}
            />
        </div>
    )
}

export default GeofenceProfileList